// Licensor-onboarding config. Separate from the VPM upload config; same
// discipline (all from REACT_APP_* vars, mock default, feature-flagged).

export const ONBOARDING_FEATURE_ENABLED = process.env.REACT_APP_ENABLE_ONBOARDING === 'true';

// Anything other than 'live' means mock — the committed default.
export const ONBOARDING_MODE: 'mock' | 'live' =
  process.env.REACT_APP_ONBOARDING_MODE === 'live' ? 'live' : 'mock';

// Admin API base (POST /admin/licensors). Only used by the live stub; unset in mock.
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || '';
